import ComponentList from 'components/Content/ComponentList/ComponentList';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { showAtbCarouselsHomepageSelector } from 'viewModel/selectors/testTarget/showAtbCarouselsHomepageSelector';
import { showUpdateProductNameDisplayHPSelector } from 'viewModel/selectors/testTarget/showUpdateProductNameDisplayHPSelector';
import { showHomepageCarouselRatingsSelector } from 'viewModel/selectors/testTarget/showHomepageCarouselRatingsSelector';
import biIdSelector from 'selectors/user/beautyInsiderAccount/biIdSelector';
import { isAnonymousSelector } from 'selectors/auth/isAnonymousSelector';

const fields = createStructuredSelector({
    userId: biIdSelector,
    isAnonymous: isAnonymousSelector,
    isCarouselsATBEnabled: showAtbCarouselsHomepageSelector,
    showUpdateProductNameDisplayHP: showUpdateProductNameDisplayHPSelector,
    isHomepageCarouselRatingsEnabled: showHomepageCarouselRatingsSelector
});

export default connect(fields)(ComponentList);
